import { Action } from 'redux'
import { isType } from 'ts-action'
import { IOriginalShiftReducer, IShift } from 'models/Shift'
import {
  GetOriginalShift,
  OriginalShiftFetching,
  ClearOriginalShiftReducer,
} from './actions'

const initialState: IOriginalShiftReducer = {
  originalShift: {} as IShift,
  originalShiftIsFetching: false,
}

/**
 * Reducer for the original shift when editing/copying a shift [NEW EDIT SHIFT, NEW COPY SHIFT PAGES]
 */
export const originalShiftReducer = (
  state = initialState,
  action: Action,
): IOriginalShiftReducer => {
  if (isType(action, GetOriginalShift)) {
    const { payload } = action
    return {
      ...state,
      originalShift: payload,
    }
  }

  if (isType(action, OriginalShiftFetching)) {
    const { payload } = action
    return {
      ...state,
      originalShiftIsFetching: payload,
    }
  }

  if (isType(action, ClearOriginalShiftReducer)) {
    return initialState
  }

  return state
}
